import { ChevronRight, NotebookPen } from 'lucide-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useAppStore } from '@/store/useAppStore'
import { useNotebooklmStore } from '@/store/useNotebooklmStore'

/** 実行中の NotebookLM 取り込みを一覧の上部に出す。完了・失敗はトーストと通知タブに任せる */
export const NotebooklmProgressBanner = () => {
  const navigate = useNavigate()
  const hasFullAccess = useAppStore((s) => s.hasFullAccess)
  const jobs = useNotebooklmStore((s) => s.jobs)
  const ensureActiveJobsLoaded = useNotebooklmStore((s) => s.ensureActiveJobsLoaded)

  useEffect(() => {
    if (!hasFullAccess) return
    void ensureActiveJobsLoaded()
  }, [hasFullAccess, ensureActiveJobsLoaded])

  const active = [...jobs.values()].filter((job) => job.status === 'pending' || job.status === 'running')
  if (!hasFullAccess || active.length === 0) return null

  const job = active[0]

  return (
    <button
      onClick={() => navigate('/notifications?tab=notebooklm')}
      className="w-full bg-sky-950/80 px-3 py-1.5 text-left"
    >
      <div className="flex items-center gap-2 text-[11px] text-sky-200">
        <NotebookPen size={12} className="shrink-0" />
        <span className="flex-1 truncate">
          NotebookLM {job.message || '取り込み中'}
          {job.productTitle && ` : ${job.productTitle}`}
          {active.length > 1 && ` 他${active.length - 1}件`}
        </span>
        <span className="shrink-0 tabular-nums">
          {job.progress}%{job.totalSources > 0 && ` (${job.processedSources}/${job.totalSources})`}
        </span>
        <ChevronRight size={12} className="shrink-0" />
      </div>
      <div className="mt-1 h-0.5 bg-white/15">
        <div className="h-full bg-sky-400 transition-all" style={{ width: `${job.progress}%` }} />
      </div>
    </button>
  )
}
